<template>
  <div>
    <div v-if="loading">
      <loading-spinner />
    </div>

    <div v-if="!loading">
      <!-- class="settings-content" -->
      <b-breadcrumb :items="navigationItems" />
      <b-modal
        id="delete-configuration"
        ref="deleteConfiguration"
        title="Delete Publisher Configuration"
        @ok="handleDeleteOK"
        @hidden="resetModal"
      >
        <p>Are you sure you want to delete : <b>{{ configuration.name }}</b></p>
      </b-modal>
      <b-container>
        <b-row align-v="center">
          <b-col
            cols="12"
            class="pl-0"
          >
            <h2 style="display:inline">
              Configurations for {{ (clientName.text) ? clientName.text : "Please select a Publisher" }}
            </h2>
          </b-col>
        </b-row>
        <b-row align-v="center">
          <b-col
            cols="6"
            class="form-row"
          >
            <router-link
              class="navigation-links"
              disabled="true"
              :to="{name: 'alternativePayments', params: { clientId: clientSelectedCode }}"
            >
              View Alternative Payments
            </router-link>
          </b-col>
          <b-col
            cols="6"
            class="form-row"
            align-h="end"
          >
            <b-col
              cols="5"
              class="text-right align-self-center"
            >
              <label
                for="table-search"
              >Search:</label>
            </b-col>
            <b-col cols="7">
              <b-form-input
                id="table-search"
                v-model="search"
                type="text"
              />
            </b-col>
          </b-col>
        </b-row>
        <br>
        <b-row>
          <b-table
            v-b-scrollspy
            outlined
            striped
            hover
            :items="items"
            head-variant="light"
            :fields="computeTableFields"
            :current-page="currentPage"
            show-empty
            empty-text="No configurations created for selected publisher."
            :per-page="perPage"
            :filter="search"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-compare="sortCompareForConfigurations"
          >
            <template v-slot:cell(name)="data">
              <router-link
                class="navigation-links"
                :to="{name: 'editConfiguration', params: { id: data.item.configurationId }}"
              >
                {{ data.item.configurationId }}
              </router-link>
              <p>
                <small>
                  <i>
                    {{ data.item.name }}
                  </i>
                  {{ data.item.description }}
                </small>
              </p>
            </template>
            <template v-slot:cell(cards)="data">
              <img
                v-for="(card, index) in data.item.cards"
                :key="index"
                :src="'/static/images/logos/' + card + '.png'"
                height="40"
              >
            </template>
            <template v-slot:cell(alt_payments)="data">
              <img
                v-for="(payment, index) in data.item.alt_payments"
                :key="index"
                :src="'/static/images/logos/' + payment + '.png'"
                height="40"
              >
            </template>
            <template v-slot:cell(expiresAt)="data">
              <div v-if="data.item.expiresAt">
                {{ data.item.expiresAt.toLocaleDateString() }} {{ data.item.expiresAt.toLocaleTimeString() }}
              </div>
            </template>
            <template v-slot:cell(actions)="data">
              <b-link
                class="navigation-links"
                @click="duplicateConfiguration(data.item.configurationId, data.item.name)"
              >
                Duplicate
              </b-link>
              |
              <b-link
                v-if="!data.item.expiresAt"
                v-b-modal="'delete-configuration'"
                class="navigation-links"
                @click="updateDeletedItem(data.item)"
              >
                Delete
              </b-link>
              <b-link
                v-if="data.item.expiresAt"
                class="navigation-links"
                @click="restoreConfiguration(data.item.configurationId)"
              >
                Restore
              </b-link>
            </template>
          </b-table>
        </b-row>
        <b-row>
          <b-col v-show="showPagination">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              :align="center"
            />
          </b-col>
        </b-row>

        <div class="button-action-ct">
          <b-button
            variant="primary"
            @click="createNewConfiguration"
          >
            Create New
          </b-button>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '../UIComponents/LoadingSpinner'
import { dataAPI } from '../services/DataAPI.js'

var items = []

export default {
  name: 'Configurations',
  components: {
    LoadingSpinner
  },
  data() {
    return {
      sortBy: 'name',
      sortDesc: true,
      configuration: { data: null, configurationId: null },
      fields: [
        {
          key: 'name',
          label: 'Configuration',
          sortable: true
        },
        {
          key: 'cards',
          label: 'Accepted Cards',
          sortable: true
        },
        {
          key: 'alt_payments',
          label: 'Alternative Payments',
          sortable: true
        },
        {
          key: 'bill_me',
          label: 'Bill Me Later',
          sortable: true
        },
        {
          key: 'wallet',
          label: 'Wallet',
          sortable: true
        },
        {
          key: 'expiresAt',
          label: 'Expiration',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false
        }
      ],
      loading: true,
      showExpiring: true,
      items: [],
      search: null,
      perPage: 10,
      currentPage: 1,
      totalRows: items.length,
      navigationItems: [{
        text: 'Home',
        to: { name: 'home' }
      }, {
        text: 'Payments',
        to: { name: 'client' }
      }, {
        text: 'Configurations',
        active: true
      }],
      clientSelectedCode: this.$route.params.clientId,
      clientSelectedId: 0
    }
  },
  computed: {
    currentUserToken() {
      return this.$store.state.auth.userToken
    },
    showPagination() {
      return (this.totalRows > this.perPage)
    },
    clientName() {
      return this.$store.state.client.clientSelected
    },
    computeTableFields() {
      if (this.showExpiring) {
        return this.fields
      }
      return this.fields.filter(f => f.key !== 'expiresAt')
    }
  },
  watch: {
    // call again the method if the route changes
    $route: 'fetchData'
  },
  created() {
    this.fetchData()
  },
  methods: {
    resetModal() {
      this.configuration = {
        name: null,
        configurationId: null
      }
    },
    updateDeletedItem(item) {
      if (item) {
        this.configuration = item
      }
    },
    restoreConfiguration(configurationId) {
      return dataAPI(this.currentUserToken).restoreConfiguration(configurationId)
        .then(() => {
          this.fetchData()
        })
    },
    hideDeleteModal() {
      this.$refs.deleteConfiguration.hide()
    },
    handleDeleteOK() {
      this.handleDeleteSubmit()
    },
    handleDeleteSubmit() {
      const { configurationId } = this.configuration
      if (!configurationId) {
        return
      }
      return dataAPI(this.currentUserToken)
        .deleteConfiguration(configurationId)
        .then((data) => {
          this.resetModal()
          this.hideDeleteModal()
          this.fetchData()
        }).catch(function (error) {
          console.error('Error occurred deleting  configuration', error)
          this.error = `Error deleting configuration for ${configurationId}`
        })
    },
    sortCompareForConfigurations(a, b, key) {
      if (key === 'name') {
        return a.configNumber < b.configNumber ? -1 : (a.configNumber > b.configNumber ? 1 : 0)
      } else if (key === 'cards') {
        return a.cards.length < b.cards.length ? -1 : (a.cards.length > b.cards.length ? 1 : 0)
      } else if (key === 'alt_payments') {
        return a.alt_payments.length < b.alt_payments.length ? -1 : (a.alt_payments.length > b.alt_payments.length ? 1 : 0)
      } else if (typeof a[key] === 'number' && typeof b[key] === 'number') {
        // If both compared fields are native numbers
        return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
      } else {
        // Stringify the field data and use String.localeCompare
        return JSON.stringify(a[key]).localeCompare(JSON.stringify(b[key]), undefined, {
          numeric: true
        })
      }
    },
    formatNameWithDesc(value) {
      return { name: `${value.name}` }
    },
    fetchData() {
      this.error = null
      this.loading = true
      const vm = this
      dataAPI(vm.currentUserToken).fetchAllConfigsPerClient_DataAPI(vm.clientSelectedCode).then((data) => {
        vm.loading = false
        vm.items = data
        vm.totalRows = data.length
      }).catch(function (error) {
        console.error('Error occurred fetching configs for Client: ', error)
        this.error = `Error loading page for ${this.clientSelectedCode}`
      })
    },
    duplicateConfiguration(dupeConfigId, name) {
      const vm = this
      dataAPI(vm.currentUserToken).duplicateConfiguration(dupeConfigId, name).then(({ data }) => {
        return this.$router.push({
          name: 'editConfiguration',
          params: {
            clientId: this.clientSelectedCode,
            id: data.configurationId
          }
        }).catch((error) => {
          console.error('Error occurred while incrementing global counter', error)
        })
      })
    },
    createNewConfiguration() {
      return this.$router.push({
        name: 'editConfiguration',
        params: {
          clientId: this.clientSelectedCode,
          id: 'new'
        }
      })
    }
  }
}
</script>

<style>
.navigation-links {
  text-decoration: underline;
  text-underline-position: under;
}
</style>

